import { RemixRoutes } from '~/core/remix';

/**
 * Dynamically redirects the user to the right "add payment method" page.
 *
 * @param bookingId The booking ID the payment method is for
 * @param returnUrl The URL to redirect the user back to after they've added a payment method
 * @param turboRedirectOrigin Whether the redirect should come back to mapp or not.
 */
export async function redirectToAddPaymentMethodPage({
  bookingId,
  returnUrl,
  turboRedirectOrigin,
}: {
  bookingId: string;
  returnUrl: string;
  turboRedirectOrigin?: Parameters<typeof RemixRoutes.payments.addCard>[2];
}) {
  window.location.href = RemixRoutes.payments.addCard(bookingId, returnUrl, turboRedirectOrigin);
}

/**
 * Dynamically redirects the user to the right "add payment method" page.
 *
 * @param bookingId The booking ID the payment method is for
 */
export async function redirectToAddPaymentMethodPageFromPassPage(bookingId: string) {
  redirectToAddPaymentMethodPage({
    bookingId,
    returnUrl: `/pass/${bookingId}`,
    turboRedirectOrigin: 'mapp',
  });
}

/**
 * Dynamically redirects the user to the right "add payment method" page for ~during the booking
 * flow~ before we have a booking ID.
 * @param locationId The location ID the payment method is for
 * @param nextPage The "page" in the booking flow that is up next. This isn't a URL but a value that
 *                 the booking flow code knows how to handle.
 */
export async function redirectToAddPaymentMethodDuringNewBookingPage(
  locationId?: string,
  nextPage?: string
) {
  if (!locationId) {
    console.error('Attempted to redirect to add payment method page without a location ID');
    return;
  }

  window.location.href = RemixRoutes.payments.addCardDuringNewBooking(locationId, nextPage);
}
